import Job from '../containers/Job';

async function retrieveJob(id) {
  const path = window.Urls['manualApi:jobDetail'](id);
  const resp = await fetch(path);
  const json = await resp.json();

  const data = new Job();
  data.load(json);
  return data;
}

export default retrieveJob;
